import React from "react";
import I18n from "../../../../base/i18n.js";

import { withStyles } from '@material-ui/styles';
import withCurrentUser from '../../../../hocs/with_current_user.js';
import withShowToast from '../../../../hocs/with_show_toast.js';
import withLocationSearchFilter from '../../../../hocs/with_location_search_filter.js';
import { compose } from 'redux';

import pageStyles from "../../../styles/page_styles.js";

import ButtonLink from "../../../../base/links/button_link.js";

import { AdminCompanyModel } from "../../../../models/companies/admin/company_model.js";
import ListCompaniesUseCase from "../../../../use_cases/admin/companies/companies/list_companies_use_case.js";

import BaseListPage from "../../base_list_page.js";
import Routes from "../../../routes.js";
import { Route } from "react-router-dom";

const styles = theme => ({
});

class CompaniesListPage extends BaseListPage {

  headerContent() {
    const { classes } = this.props;
    return <React.Fragment>
      <ButtonLink className = { classes.button }
                  to = { Routes.company("new") } >
        { I18n.t("admin.companies.company.action.new") }
      </ButtonLink>
    </React.Fragment>
  }
  
}

CompaniesListPage.defaultProps = {
  dataModel: AdminCompanyModel,
  listUseCase: ListCompaniesUseCase,
  
}

export default compose(
  withLocationSearchFilter,
  withShowToast, 
  withCurrentUser, 
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(CompaniesListPage);
